import React from 'react';
import { useSelector } from 'react-redux';
import { domain } from '../utils/variables';

const useOfficialDomain = () => {
  const parentAlpha2 = useSelector(
    state => state?.locations?.yourLocation?.parentTerritory?.alpha2,
  );
  const alpha2 = useSelector(state => state?.locations?.yourLocation?.alpha2);

  const siteWide = useSelector(state => state?.locations?.siteWide);

  const fatumAllowedDomains =
    siteWide?.fatumAllowedDomains || domain?.fatumAllowedDomains;
  const otherAllowedDomains = siteWide?.allowedPWADomains || domain?.allowedPWADomains;

  const fatumOfficialDomain = siteWide?.fatumPWA || domain?.fatumPWA;
  const pwaOfficialDomain = siteWide?.pwa || domain?.pwa;

  const tempAllowedDomains =
    alpha2 && parentAlpha2 === 'AN' ? fatumAllowedDomains : otherAllowedDomains;
  const allowedDomains = tempAllowedDomains?.split(',');
  const isUnofficialDomainAllowed =
    allowedDomains && allowedDomains?.some(x => window.location.href.indexOf(x) > -1);

  let officialDomain = null;
  let otherDomain = null;
  if (alpha2) {
    if (parentAlpha2 === 'AN') {
      officialDomain = fatumOfficialDomain;
      otherDomain = pwaOfficialDomain;
    } else {
      officialDomain = pwaOfficialDomain;
      otherDomain = fatumOfficialDomain;
    }
  }

  return {
    isUnofficialDomainAllowed,
    officialDomain,
    siteWide,
    allowedDomains,
    alpha2,
    parentAlpha2,
    otherDomain,
  };
};

export default useOfficialDomain;
